import { routes } from "../../constants/routes";
export const breadcrumbLink = [
  {
    label: "Lead Management",
    link: routes.LEADLIST,
    handleClick: () => {},
  },
  {
    label: "Leads",
    link:routes.LEADLIST,
    handleClick: () => {},
  },
];
export const breadcrumbLinkSocialImport = () => [
  {
    label: "Leads",
    link:routes.LEADLIST,  
  },
  {
    label: "Social Import",
    link: routes.SOCIALIMPORTLEAD,
    handleClick: () => {},
  },
];
